import { createSelector } from 'reselect';

const selectnexusARecordTypes = (state: any) => state.nexusARecordTypes;


export const selectnexusARecordTypesCurrentItem = createSelector([selectnexusARecordTypes], (nexusARecordTypes) => nexusARecordTypes.current);

export const selectnexusARecordTypesListItems = createSelector([selectnexusARecordTypes], (NexusARecordTypes) => NexusARecordTypes.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectnexusARecordTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectnexusARecordTypesQueryItems = createSelector([selectnexusARecordTypes], (nexusARecordTypes) => nexusARecordTypes.query);

export const selectnexusARecordTypesCreatedItem = createSelector([selectnexusARecordTypes], (nexusARecordTypes) => nexusARecordTypes.create);

export const selectnexusARecordTypesUpdatedItem = createSelector([selectnexusARecordTypes], (nexusARecordTypes) => nexusARecordTypes.update);

export const selectnexusARecordTypesReadItem = createSelector([selectnexusARecordTypes], (nexusARecordTypes) => nexusARecordTypes.read);

export const selectnexusARecordTypesDeletedItem = createSelector([selectnexusARecordTypes], (nexusARecordTypes) => nexusARecordTypes.delete);

export const selectnexusARecordTypesSearchedItems = createSelector([selectnexusARecordTypes], (nexusARecordTypes) => nexusARecordTypes.search);

export const selectnexusARecordTypesItemsCount = createSelector([selectnexusARecordTypes], (nexusARecordTypes) => nexusARecordTypes.count);

export const selectnexusARecordTypesItemsFilter = createSelector([selectnexusARecordTypes], (nexusARecordTypes) => nexusARecordTypes.filter);